// export function classNames(...classes) {
//   return classes.filter(Boolean).join(" ");
// }

import clsx from "clsx";
import { twMerge } from "tailwind-merge";

// Combine clsx and tailwind-merge
export function classNames(...inputs) {
  return twMerge(clsx(...inputs));
}
